module.exports = __webpack_public_path__ + "bf22983f1546ba15ead1bdea9ca06395.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/pt.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/pt.svg
// module chunks = 0